import React from 'react'
import styles from '@/src/components/scss/Schedule.module.scss'
import { Box } from '@mui/material'
import { Typography, Button } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import Time24 from '@evocolabs/icons/lib/Time24'
import { useSchedule } from '@/components/Schedule/ScheduleRoot'
import { useCalendar } from '@/components/Schedule/Calendar/CalendarProvider'
import { useBackend } from '@/src/providers/BackendProvider'

const AppointmentScheduled = () => {
  const {
    viewId,
    setViewId,
    history,
    date,
    time,
    setDate,
    setTime,
    params,
    cancel,
    setErrorOpen
  } = useSchedule()
  const { monthList, refreshAvailableTimeSlots } = useCalendar()
  const { refreshAppointment } = useBackend()

  async function handleReschedule() {
    await refreshAvailableTimeSlots()
    setDate({
      year: null,
      month: null,
      date: null
    })
    setTime({
      idx: -1,
      start: -1,
      end: -1
    })
    history.push(viewId)
    await refreshAppointment()
    setViewId(viewId - 1)
  }

  async function handleCancel() {
    const token = params.token
      ? params.token
      : JSON.parse(window.sessionStorage.getItem('schedule-token'))
    const id = params.id
      ? params.id
      : JSON.parse(window.sessionStorage.getItem('appointment-id'))
    if (id) {
      const res = await cancel(token, id)
      if (res.status < 300) {
        history.push(viewId)
        await refreshAppointment()
        setViewId(viewId + 1)
        window.sessionStorage.removeItem('schedule-token')
        window.sessionStorage.removeItem('appointment-id')
        return res
      } else {
        setErrorOpen(true)
        return res
      }
    }
  }

  function ordinal(n) {
    return ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th'
  }

  return (
    <Box className={styles.viewRoot}>
      <Typography variant="h3">Appointment Scheduled!</Typography>
      <Typography variant="body1" sx={{ mt: '16px' }}>
        Your consultation with Orka's audiologist is scheduled during{' '}
        {new Date(
          date.year,
          date.month,
          date.date,
          time.start,
          (time.start % 1) * 60
        )
          .toTimeString()
          .substring(0, 5)}{' '}
        -{' '}
        {new Date(
          date.year,
          date.month,
          date.date,
          time.end,
          (time.end % 1) * 60
        )
          .toTimeString()
          .substring(0, 5)}{' '}
        {date.date}
        {ordinal(date.date)} {monthList[date.month]}, {date.year}, where you
        will receive a phone call from us.
      </Typography>
      <Box
        className={styles.appointmentBox}
        bgcolor={theme.palette.primary[100]}
      >
        <Time24 />
        <Box sx={{ ml: '8px' }}>
          <Typography variant="subh1">Appointment</Typography>
          <Typography
            variant="subh2"
            sx={{
              color: theme.palette.primary[700],
              mt: '8px'
            }}
          >
            {new Date(
              date.year,
              date.month,
              date.date,
              time.start,
              (time.start % 1) * 60
            )
              .toTimeString()
              .substring(0, 5)}{' '}
            - {}
            {new Date(
              date.year,
              date.month,
              date.date,
              time.end,
              (time.end % 1) * 60
            )
              .toTimeString()
              .substring(0, 5)}
            , {}
            {date.date > 9 ? '' : '0'}
            {date.date}/{date.month > 8 ? '' : '0'}
            {date.month + 1}/{date.year}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ textAlign: 'left' }}>
        <Button
          size="large"
          style={{ marginRight: '16px' }}
          handleClick={handleReschedule}
          loadable
        >
          reschedule
        </Button>
        <Button
          variant="secondary"
          size="large"
          handleClick={handleCancel}
          loadable
        >
          cancel
        </Button>
      </Box>
    </Box>
  )
}

export default AppointmentScheduled
